import _ from 'lodash';
import {get, post} from 'sdk';
import {BASE_URL} from 'appConstants';

import {transformSortForStoreToSortForUrl} from 'utils/sort';
import {transformFiltersForStoreToFiltersForApi} from 'utils/filters';
import {getFormattedDateForApiOrValue} from 'utils/datetime';

export const fetchPayments = ({locationRef, extraGetParams}) => {
  const url = `${BASE_URL}/v1/payments/${locationRef}/list/`;

  return get(url, extraGetParams);
};

export const fetchPaymentsCreatedBy = ({locationRef, search}) => {
  const url = `${BASE_URL}/v1/payments/${locationRef}/created-by/`;

  return get(url, {search});
};

export const fetchPaymentsForBooking = ({locationRef, search}) => {
  const url = `${BASE_URL}/v1/payments/${locationRef}/for-booking/`;

  return get(url, {search});
};

export const fetchScheduleTypesFilters = () => {
  const url = `${BASE_URL}/v1/payments/schedule/schedule-types-filters/`;

  return get(url);
};

export const fetchXeroAccountsFilters = ({locationRef}) => {
  const url = `${BASE_URL}/v1/payments/${locationRef}/xero-accounts/options-for-payments-list/`;

  return get(url);
};

export const fetchOneOffChargeReasonFilters = ({locationRef}) => {
  const url = `${BASE_URL}/v1/payments/${locationRef}/one-off-charge-reason-filters-list/`;

  return get(url);
};

export const voidInvoices = ({invoices}) => {
  const url = `${BASE_URL}/v1/payments/void/invoices/`;

  return post(url, {invoices});
};

export const exportPaymentsCsvInBackground = ({filters, locationRef, sort}) => {
  const url = `${BASE_URL}/v1/payments/${locationRef}/export-in-background/`;

  const normalizedFilters = _.mapValues(filters, getFormattedDateForApiOrValue);

  const filterParams = {
    ...transformFiltersForStoreToFiltersForApi(normalizedFilters),
    ...transformSortForStoreToSortForUrl(sort)
  };

  return get(url, filterParams);
};

export const fetchCreditNotes = ({locationRef, extraGetParams}) => {
  const url = `${BASE_URL}/v1/payments/${locationRef}/credit-notes/list/`;

  return get(url, extraGetParams);
};

export const exportCreditNotesCsv = ({filters, locationRef, sort}) => {
  const url = `${BASE_URL}/v1/payments/${locationRef}/credit-notes/csv-export/`;

  const normalizedFilters = _.mapValues(filters, getFormattedDateForApiOrValue);

  const filterParams = {
    ...transformFiltersForStoreToFiltersForApi(normalizedFilters),
    ...transformSortForStoreToSortForUrl(sort)
  };

  return get(url, filterParams);
};
